export default {"src":"/login-app/[GIT_HASH]/_next/static/media/schedule.1037e1b0.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};